// extracted by mini-css-extract-plugin
module.exports = {"preTitle":"e_kz","content":"e_lz"};